import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { bool_type, int32_type, record_type, option_type, class_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { sortByDescending } from "../../fable_modules/fable-library.3.7.20/List.js";
import { compareArrays, equals } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { DateTimeOffset_getDateStatus, DateStatus } from "../../DateUtils.js";
import { compare } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { now } from "../../fable_modules/fable-library.3.7.20/DateOffset.js";

export class NumberHistoryDTO extends Record {
    constructor(NumberFrom, NumberTo, ActiveFrom, ActiveTo, Icc, Imsi) {
        super();
        this.NumberFrom = NumberFrom;
        this.NumberTo = NumberTo;
        this.ActiveFrom = ActiveFrom;
        this.ActiveTo = ActiveTo;
        this.Icc = Icc;
        this.Imsi = Imsi;
    }
}

export function NumberHistoryDTO$reflection() {
    return record_type("Containers.Subscriptions.Common.NumberHistoryDTO", [], NumberHistoryDTO, () => [["NumberFrom", string_type], ["NumberTo", string_type], ["ActiveFrom", option_type(class_type("System.DateTimeOffset"))], ["ActiveTo", option_type(class_type("System.DateTimeOffset"))], ["Icc", option_type(class_type("System.Decimal"))], ["Imsi", option_type(class_type("System.Int64"))]]);
}

export function NumberHistoryDTO_SortByActiveFrom_285C6A16(numberHistoryDTOs) {
    return sortByDescending((nh) => {
        let matchValue;
        return [equals((matchValue = nh.ActiveFrom, (matchValue == null) ? (new DateStatus(4)) : DateTimeOffset_getDateStatus(matchValue, nh.ActiveTo)), new DateStatus(0)), nh.ActiveTo, nh.ActiveFrom];
    }, numberHistoryDTOs, {
        Compare: compareArrays,
    });
}

export class NumberHistory extends Record {
    constructor(NumberFrom, NumberTo, ActiveFrom, ActiveTo, Icc, Imsi, Index) {
        super();
        this.NumberFrom = NumberFrom;
        this.NumberTo = NumberTo;
        this.ActiveFrom = ActiveFrom;
        this.ActiveTo = ActiveTo;
        this.Icc = Icc;
        this.Imsi = Imsi;
        this.Index = (Index | 0);
    }
}

export function NumberHistory$reflection() {
    return record_type("Containers.Subscriptions.Common.NumberHistory", [], NumberHistory, () => [["NumberFrom", string_type], ["NumberTo", string_type], ["ActiveFrom", option_type(class_type("System.DateTimeOffset"))], ["ActiveTo", option_type(class_type("System.DateTimeOffset"))], ["Icc", option_type(class_type("System.Decimal"))], ["Imsi", option_type(class_type("System.Int64"))], ["Index", int32_type]]);
}

export function NumberHistory_OfDTO(index, dto) {
    return new NumberHistory(dto.NumberFrom, dto.NumberTo, dto.ActiveFrom, dto.ActiveTo, dto.Icc, dto.Imsi, index);
}

export function NumberHistory_IsActive_Z5E3A5CDD(nh) {
    const matchValue = [nh.ActiveFrom, nh.ActiveTo];
    if (matchValue[0] != null) {
        if (matchValue[1] != null) {
            const activeTo = matchValue[1];
            return compare(activeTo, now()) > 0;
        }
        else {
            return true;
        }
    }
    else {
        return false;
    }
}

export class Sim extends Record {
    constructor(Icc, Imsi, Pin, Puk, SimTypeCode, Imei, Brand, Model, Supports5G, PackageNumber) {
        super();
        this.Icc = Icc;
        this.Imsi = Imsi;
        this.Pin = Pin;
        this.Puk = Puk;
        this.SimTypeCode = SimTypeCode;
        this.Imei = Imei;
        this.Brand = Brand;
        this.Model = Model;
        this.Supports5G = Supports5G;
        this.PackageNumber = PackageNumber;
    }
}

export function Sim$reflection() {
    return record_type("Containers.Subscriptions.Common.Sim", [], Sim, () => [["Icc", string_type], ["Imsi", class_type("System.Int64")], ["Pin", string_type], ["Puk", string_type], ["SimTypeCode", string_type], ["Imei", option_type(string_type)], ["Brand", option_type(string_type)], ["Model", option_type(string_type)], ["Supports5G", option_type(bool_type)], ["PackageNumber", option_type(string_type)]]);
}

